import { cn } from '@/lib/utils';
import { Skeleton } from '@/components/ui/Skeleton.tsx';
import {
  InfoCard,
  InfoCardBody,
  InfoCardHeader,
} from '@/components/ui/InfoCard.tsx';

interface RecentChangesCardSkeletonProps
  extends React.HTMLAttributes<HTMLDivElement> {
  /** Rezerwuje wyróżniony wiersz otwartego szkicu. */
  withDraft?: boolean;
  /** Ile wpisów historii odwzorować. */
  historyCount?: number;
}

/** Szkielet karty „Ostatnie zmiany”: wiersz szkicu i wprowadzone paczki. */
const RecentChangesCardSkeleton = ({
  withDraft = true,
  historyCount = 2,
  ...props
}: RecentChangesCardSkeletonProps) => (
  <InfoCard {...props}>
    <InfoCardHeader title={<Skeleton className="h-3.5 w-32" />} />

    {withDraft && (
      <div className="flex items-start gap-2.5 border-b border-neutral-100 bg-neutral-50 px-5 pb-4 pt-3.5">
        <Skeleton className="mt-[5px] size-2 rounded-full" />
        <div className="flex flex-col gap-1.5">
          <Skeleton className="h-4 w-44" />
          <Skeleton className="h-3.5 w-56" />
        </div>
      </div>
    )}

    <InfoCardBody className="gap-3">
      {Array.from({ length: historyCount }).map((_, index) => (
        <div
          key={index}
          className={cn(
            'flex flex-col gap-1.5',
            index > 0 && 'border-t border-neutral-100 pt-3',
          )}
        >
          <Skeleton className="h-4 w-40" />
          <Skeleton className="h-3.5 w-52" />
        </div>
      ))}
    </InfoCardBody>
  </InfoCard>
);

export default RecentChangesCardSkeleton;
